(function () {
  function updateProgressBar() {
    var wrapper = document.querySelector(".progress-wrapper");
    var fill = document.getElementById("progress-fill");
    var textContainer = document.getElementById("progress-text");

    if (!wrapper || !fill || !textContainer) {
      console.log("Required elements not found");
      return;
    }

    var cartTotal = parseFloat(wrapper.getAttribute("data-cart-total")) || 0;

    // Get settings from global variable or data attributes
    var settings = window.cartProgressSettings || {};

    var t1 =
      settings.threshold1 ||
      parseFloat(wrapper.getAttribute("data-threshold-1")) ||
      1199;
    var t2 =
      settings.threshold2 ||
      parseFloat(wrapper.getAttribute("data-threshold-2")) ||
      1599;
    var t3 =
      settings.threshold3 ||
      parseFloat(wrapper.getAttribute("data-threshold-3")) ||
      1799;
    var d1 =
      settings.discount1 || wrapper.getAttribute("data-discount-1") || "10";
    var d2 =
      settings.discount2 || wrapper.getAttribute("data-discount-2") || "15";
    var d3 =
      settings.discount3 || wrapper.getAttribute("data-discount-3") || "20";

    // Get message templates from global settings or data attributes
    var msgTemplate1 =
      settings.message1 ||
      wrapper.getAttribute("data-message-1") ||
      "ADD ITEMS WORTH <strong>₹{amount}</strong> TO UNLOCK <br>Additional {discount}% Discount";
    var msgTemplate2 =
      settings.message2 ||
      wrapper.getAttribute("data-message-2") ||
      "CONGRATS! YOU UNLOCKED {discount1}% Discount 🎉<br>ADD <strong>₹{amount}</strong> Additional {discount2}% discount";
    var msgTemplate3 =
      settings.message3 ||
      wrapper.getAttribute("data-message-3") ||
      "CONGRATS! YOU UNLOCKED {discount1}% discount🎉 <br>ADD <strong>₹{amount}</strong> Additional {discount2}% Discount";
    var msgComplete =
      settings.messageComplete ||
      wrapper.getAttribute("data-message-complete") ||
      "CONGRATS! 🎉 YOU HAVE UNLOCKED ALL OFFERS!<br><strong>{discount}% Discount APPLIED</strong>";

    var pct = 0;
    var msg = "";

    if (cartTotal < t1) {
      // Fill from 0% to 33.33% (first box)
      pct = (cartTotal / t1) * 33.33;
      var diff = Math.ceil(t1 - cartTotal);
      msg = msgTemplate1.replace("{amount}", diff).replace("{discount}", d1);
    } else if (cartTotal >= t1 && cartTotal < t2) {
      // When exactly t1, show 33.33%. Fill from 33.33% to 66.66% (second box)
      pct = 33.33 + ((cartTotal - t1) / (t2 - t1)) * 33.33;
      var diff = Math.ceil(t2 - cartTotal);
      msg = msgTemplate2
        .replace("{amount}", diff)
        .replace("{discount1}", d1)
        .replace("{discount2}", d2);
    } else if (cartTotal >= t2 && cartTotal < t3) {
      // When exactly t2, show 66.66%. Fill from 66.66% to 100% (third box)
      pct = 66.66 + ((cartTotal - t2) / (t3 - t2)) * 33.34;
      var diff = Math.ceil(t3 - cartTotal);
      msg = msgTemplate3
        .replace("{amount}", diff)
        .replace("{discount1}", d2)
        .replace("{discount2}", d3);
    } else {
      // When exactly t3 or more, show 100%
      pct = 100;
      msg = msgComplete.replace("{discount}", d3);
    }

    fill.style.width = pct + "%";
    textContainer.innerHTML = msg;

    // Add full border radius when at 100%
    if (pct >= 100) {
      fill.classList.add("full");
    } else {
      fill.classList.remove("full");
    }
  }

  // Expose function globally so cart-drawer.js can call it
  window.updateProgressBar = updateProgressBar;

  // Run immediately when script loads
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", updateProgressBar);
  } else {
    updateProgressBar();
  }

  // Listen for cart drawer open event
  document.addEventListener("cartdrawer:opened", function () {
    setTimeout(updateProgressBar, 100);
  });

  // Also listen for cart updates
  document.addEventListener("cart:updated", function () {
    setTimeout(updateProgressBar, 100);
  });
})();
